import { WavesArrowUpIcon } from './WavesArrowUpIcon';

/**
 * author: Michael Irigoyen
 * id 9C20E25F-2499-4B5F-BC47-74DDA23F6DC3
 * name waves-arrow-up
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/waves-arrow-up.svg
 * tags
 * - Nature 
 * - Weather 
 */
export const SeaLevelRiseIcon = WavesArrowUpIcon;
export default SeaLevelRiseIcon